import { USER_FOUND, USER_EXPIRED, SILENT_RENEW_ERROR, REDIRECT_SUCCESS } from 'redux-oidc';

const userManagerInitialState = {
    isActive: null,
    roles: [],
    userInfo: {},
    fetchingRoles: false,
    loggingIn: false,
    returnPath: null
};

export default function userManagerReducer(state = userManagerInitialState, action) {
    switch (action.type) {
        case USER_FOUND: {
            return { ...state, loggingIn: false, fetchingRoles: false, userExpired: false }
        }

        case USER_EXPIRED: {
            return { ...state, loggingIn: false, fetchingRoles: false, userExpired: true, isActive: null }
        }

        case "USER_LOGIN": {
            return { ...state, loggingIn: true, fetchingRoles: false, userExpired: false, isActive: null, returnPath: action.payload }
        }

        case "USER_LOGIN_ERROR": {
            return { ...state, loggingIn: false };
        }

        case REDIRECT_SUCCESS: {
            return { ...state, loggingIn: false, userInfo: action.payload }
        }

        case "FETCH_USER_INFO": {
            return { ...state, fetchingRoles: true }
        }

        case "FETCH_USER_INFO_FULFILLED": {
            return { ...state, fetchingRoles: false, roles: action.payload.data.userRoles, userInfo: action.payload.data, isActive: action.payload.data.isActive }
        }

        case "FETCH_USER_INFO_REJECTED": {
            return { ...state, fetchingRoles: false, isActive: false, roles: [], userInfo: null }
        }

        case "USER_LOGOUT": {
            return { ...state, loggingIn: false, userInfo: null, isActive: false, roles: [], fetchingRoles: false }
        }

        case SILENT_RENEW_ERROR: {
            return { ...state, loggingIn: false, userInfo: null, isActive: false, roles: [], fetchingRoles: false }
          }

        default: {
            return state
        }
    }
}